import { IServerValidation } from '../../../domain/validation/interfaces';
import { post } from '../../../DAL/data-provider';
import { IUtm } from '../../../domain/marketing/utm/utm-interfaces';

/**
 * message gears subscribe
 */
export const subscribeToMessageGears = async (
    formName: string,
    email: string,
    captchaCode: string,
    recaptchaVersion: number,
    nodeGuid: string,
    utm: IUtm|null,
    firstName?: string,
    lastName?: string
) : Promise<{data: IServerValidation, statusCode: number }> => {

    return post('/api/messagegears/subscribe', {
        formName,
        email,
        captchaCode,
        recaptchaVersion,
        nodeGuid,
        firstName,
        lastName,

        firstUTMSource: utm ? utm.firstSource : '',
        firstUTMMedium: utm ? utm.firstMedium : '',
        firstUTMCampaign: utm ? utm.firstCampaign : '',

        lastUTMSource: utm ? utm.lastSource : '',
        lastUTMMedium: utm ? utm.lastMedium : '',
        lastUTMCampaign: utm ? utm.lastCampaign : '',
    });
};


/**
 * Confirm Message Gears subscription when double option is enabled for the given form.
 * https://dev13.waves.com/newsletter-subscription-confirmation?RecipientGUID=2f9257c0-e5b6-4edf-aad8-9986530698e2
 */
export const confirmNewsletter = async (guid: string) : Promise<{data: IServerValidation, statusCode: number }> => {
    return post('/api/messagegears/confirm-subscription', {
        guid,
    });
};